import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';

export enum BeneficiaryType {
  Account = 'account',
  OtherAsset = 'otherAsset',
}

export interface States {
  id: string;
  entityId?: string;
  simulatedAccountType?: string;
  state: boolean;
}

interface Body {
  type: BeneficiaryType;
  simulated: boolean;
  states: States[];
}

const saveCheck = (clientId: number) => (body: Body) => {
  return authFetch('/Consumer/AccountBeneficiariesUpdateV2/SaveChecked', {
    method: 'POST',
    ...httpBodyOptions({ ...body, clientId }, true),
  });
};

export const useAccountBeneficiariesSaveCheckMutation = () => {
  const queryClient = useQueryClient();

  const clientId = useClientId();

  const fpId = useFpId();

  return useMutation(saveCheck(clientId), {
    async onSuccess() {
      const queryKey = queryKeys.estatePlanningExplanation(clientId, fpId);

      await queryClient.invalidateQueries(queryKey);
    },
  });
};
